import React from 'react';
import './customtabletFilter.css';
import { CustomTooltip } from '../CustomTooltip/CustomTooltip';

export const CustomTabletFilter = ({ withTooltip = false, placementTooltip, textTooltip, idTargetTooltip = '', filterName, deleteFilterFunction }) => {
    return (
        <>
            {withTooltip ? <CustomTooltip placement={placementTooltip} text={textTooltip} target={idTargetTooltip} /> : null}
            <div id={idTargetTooltip} className='tablet-bk d-flex align-items-end gap-2'>
                <span>{filterName}</span>

                {deleteFilterFunction ?
                    <i
                        type='button'
                        className="fa-solid fa-xmark"
                        style={{ color: 'var(--gray-900)' }}
                        onClick={deleteFilterFunction}
                    >
                    </i>
                    : null
                }

            </div>
        </>
    )
}
